import { initialState } from "./selectors";
import {
  GET_DAILY_QUEST_REQUEST,
  GET_DAILY_QUEST_SUCCESS,
  ANSWER_DAILY_QUEST_REQUEST,
  ANSWER_DAILY_QUEST_SUCCESS,
  HIDE_DAILY_QUEST_MODAL,
  SHOW_DAILY_QUEST_MODAL,
  SHOW_QUEST_ANIMATION,
  HIDE_QUEST_ANIMATION,
} from "./actions";

export default function brand(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case GET_DAILY_QUEST_REQUEST:
      return {
        ...state,
      };
    case GET_DAILY_QUEST_SUCCESS:
      return {
        ...state,
        questData: payload,
      };
    case ANSWER_DAILY_QUEST_REQUEST:
      return {
        ...state,
      };
    case ANSWER_DAILY_QUEST_SUCCESS:
      return {
        ...state,
        questAnswer: payload,
      };
    case SHOW_DAILY_QUEST_MODAL:
      return {
        ...state,
        questModalVisible: true,
      };
    case HIDE_DAILY_QUEST_MODAL:
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const closedQuestData = {
        date: today,
        clientId: localStorage.getItem("clientId"),
        profileId: localStorage.getItem("profileId"),
      };
      localStorage.setItem("dailyQuestModalClosed", JSON.stringify(closedQuestData));
      return {
        ...state,
        questData: null,
        questModalVisible: false,
      };
    case SHOW_QUEST_ANIMATION:
      return {
        ...state,
        questPointsAnimationVisible: true,
      };
    case HIDE_QUEST_ANIMATION:
      return {
        ...state,
        questPointsAnimationVisible: false,
        questAnswer: null,
      };
    default:
      return state;
  }
}
